import { h } from "preact";

import withMenuItem from "../withMenuItem";

import "../style.css";

const Divider = () => <hr/>;
const DividerAsMenuItem = withMenuItem(Divider, { highlightable: false });

export default Divider;
export { DividerAsMenuItem };
